"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TogglerTitle = exports.StyledToggleIcon = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _rebrand = require("../../icons-react/rebrand");
var _excluded = ["label", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AbstractToggler = function AbstractToggler(_ref) {
  var label = _ref.label,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(StyledAbstractToggler, rest, /*#__PURE__*/_react["default"].createElement(TogglerTitle, {
    functional: true,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, label, /*#__PURE__*/_react["default"].createElement(StyledToggleIcon, {
    isOpen: isOpen
  })), isOpen && children);
};
var StyledAbstractToggler = _styledComponents["default"].div.withConfig({
  displayName: "AbstractToggler__StyledAbstractToggler",
  componentId: "sc-ets05k-0"
})([""]);
var TogglerTitle = exports.TogglerTitle = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "AbstractToggler__TogglerTitle",
  componentId: "sc-ets05k-1"
})(["display:flex;align-items:center;"]);
var StyledToggleIcon = exports.StyledToggleIcon = (0, _styledComponents["default"])(_rebrand.ChevronUp).withConfig({
  displayName: "AbstractToggler__StyledToggleIcon",
  componentId: "sc-ets05k-2"
})(["width:12px;path{fill:var(--grey1);}", ""], function (props) {
  return !props.isOpen && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
AbstractToggler.propTypes = {
  label: _propTypes["default"].node.isRequired,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};
AbstractToggler.defaultProps = {
  className: ''
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(AbstractToggler);